import _defineProperty from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Aug 08 2018
 * @author SKu
 */
import SliderStyled from './styled/SliderStyled';
import { default as RangeSlider } from 'rc-slider';
import 'rc-slider/assets/index.css';
import * as React from 'react';
import withValidation from '../withValidation';
/**
 * Create Slider component
 */

/**
 * [See DOCS for rc-slider](https://react-component.github.io/slider/)
 */

var Slider =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Slider, _React$PureComponent);

  function Slider() {
    var _this;

    _classCallCheck(this, Slider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).apply(this, arguments));
    _this.state = {
      inputValue: _this.props.defaultValue
    };
    /**
     * Changes values in inputs after dragging slider and set values on slider
     */

    _this.updateState = function (value) {
      _this.setState({
        inputValue: value
      }, function () {
        _this.props.onChange(value);
      });
    };
    /**
     * Function allows to change input of the lower bound
     * @param e - event from input
     */


    _this.onLowerBoundChange = function (e) {
      _this.setState({
        inputValue: [Number(e.target.value), _this.state.inputValue[1]]
      });
    };
    /**
     * Function allows to change input of the upper bound
     * @param e - event from input
     */


    _this.onUpperBoundChange = function (e) {
      _this.setState({
        inputValue: [_this.state.inputValue[0], Number(e.target.value)]
      });
    };

    return _this;
  }

  _createClass(Slider, [{
    key: "render",
    value: function render() {
      var _marks;

      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max,
          unit = _this$props.unit;
      /**
       * Settings for marks
       */

      var marks = (_marks = {}, _defineProperty(_marks, this.props.min, React.createElement("strong", null, unit ? "".concat(min, " ").concat(unit) : min)), _defineProperty(_marks, this.props.max, React.createElement("strong", null, unit ? "".concat(max, " ").concat(unit) : max)), _marks);
      return React.createElement(SliderStyled, {
        className: "input-wrapper mb1"
      }, React.createElement(RangeSlider, Object.assign({}, this.props, {
        value: this.props.value,
        marks: this.props.marksEnabled ? marks : {},
        onChange: this.updateState
      })));
    }
  }]);

  return Slider;
}(React.PureComponent);

export default Slider;
export var SliderValidated = withValidation(Slider);